const styles = theme => ({
  noWrap: {
    whiteSpace: 'nowrap',
  },
})

export default styles
